import type { A11y, Classnames, ImgFit, Size } from '@snowit/icetypes';

import { Icon } from '@snowit/ui';
import { makeCSS } from '@snowit/utils/misc';

import cx from 'classnames';
import s from './Img.module.scss';

export interface IImg {
  src: string;
  alt?: string;
  size?: number | [number, number];
  fit?: ImgFit;
  ratio?: number | `${number}/${number}`;
  radius?: Size;
  showPlaceholder?: boolean;
  classNames?: Classnames<'figure' | 'img'>;
  a11y?: A11y;
}

const Img = (props: IImg) => {
  const {
    src,
    alt,
    size,
    fit = 'contain',
    ratio,
    radius,
    showPlaceholder,
    classNames,
    a11y,
  } = props;

  const sizes = Array.isArray(size) ? size : [size];
  const width = `${sizes[0]}rem`;
  const height = `${sizes[1] || sizes[0]}rem`;

  const renderImage = () => {
    if (!src && showPlaceholder) return null;
    return (
      <img
        className={cx(s.img, classNames?.img)}
        src={src || undefined}
        alt={alt}
        role={a11y?.role}
        aria-hidden={a11y?.hidden}
      />
    );
  };

  const renderPlaceholder = () => {
    if (src) return null;
    if (!showPlaceholder) return null;
    return <Icon name={'img_placeholder'} a11y={{ hidden: true }} />;
  };

  return (
    <div
      className={cx(s.figure, classNames?.figure)}
      style={makeCSS({
        '--lw': width,
        '--lh': height,
        '--lfit': fit,
        '--lratio': ratio ?? 'auto',
        '--lradius': `var(--s-${radius})`,
      })}
      role={a11y?.role}
      aria-hidden={a11y?.hidden}
    >
      {renderImage()}
      {renderPlaceholder()}
    </div>
  );
};

export default Img;
